import { SHOW_ALL } from "../i18n/keyConstants";

export const PagingShowAllText = (t) => {
    const pagingItems = Array.from(document.querySelectorAll('.dx-g-bs4-paging-panel .page-link'));
    const pagingOptions = Array.from(document.querySelectorAll('.dx-g-bs4-paging-panel option'));

    const showAllLink = pagingItems && pagingItems.find((item) => item.innerHTML === '10000');
    const showAllOption = pagingOptions && pagingOptions.find((item) => item.value === '10000');

    if (showAllLink) showAllLink.innerHTML = t(SHOW_ALL, { ns: 'shared' });
    if (showAllOption) showAllOption.innerHTML = t(SHOW_ALL, { ns: 'shared' });
};
